import paceStart from './pace-start'
import paceReset from './pace-reset'
import authentication from './authentication'
import menu from './menu'
import vlastModules from './vlast-modules'
import redirects from './redirects'

export default router => {
  // Pace start must always be called first. This renders the initial Pace loader.
  router.beforeEach(paceStart)

  router.beforeEach(authentication)
  router.beforeEach(redirects)
  router.beforeEach(vlastModules)
  router.beforeEach(menu)

  // Pace reset must always be called last. This hides the initial rendered bar and
  // resets Pace so it automatically hides itself and triggers events.
  router.beforeEach(paceReset)
}
